/**
 * Komponent GradeIndicator - wyświetla kółko/kropkę w zależności od stopnia wiarygodności
 */

import React, { FC, useMemo } from 'react';
import classnames from 'classnames';

import styles from 'theme/components/wise/WiseTable/components/GradeIndicator/GradeIndicator.module.scss';

type GradeVariant = 'undefined' | 'pending' | 'warning' | 'alert' | 'ok';

interface IGradeIndicatorProps {
  grade: string; // Wartość z API (np. "UNDEFINED", "PENDING", "WARNING", "ALERT", "OK")
}

/**
 * Funkcja mapująca grade na wariant
 */
const getGradeVariant = (grade: string): GradeVariant => {
  if (!grade || grade.trim() === '' || grade.toUpperCase() === 'UNDEFINED') {
    return 'undefined';
  }
  
  const gradeUpper = grade.toUpperCase();
  
  if (gradeUpper === 'PENDING') {
    return 'pending';
  }
  if (gradeUpper === 'WARNING') {
    return 'warning';
  }
  if (gradeUpper === 'ALERT') {
    return 'alert';
  }
  if (gradeUpper === 'OK') {
    return 'ok';
  }
  
  // Domyślnie undefined
  return 'undefined';
};

/**
 * Komponent GradeIndicator
 */
const GradeIndicator: FC<IGradeIndicatorProps> = ({ grade }) => {
  const variant = useMemo(() => getGradeVariant(grade), [grade]);

  return (
    <div
      className={classnames(styles.componentWrapper, styles[variant], 'GradeIndicator')}
      title={grade || 'UNDEFINED'}
    />
  );
};

export default GradeIndicator;
